var _this = this;
import * as tslib_1 from "tslib";
import { ExportMailboxOption, checkMailboxExportStatus } from 'owa-export-mailbox-option';
import { PrivacyOption } from 'owa-privacy-option';
var exportSubCategory = {
    key: 'export',
    titleStringKey: 'optionSubcategory_export',
    options: [ExportMailboxOption, PrivacyOption],
    onSelected: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            checkMailboxExportStatus();
            return [2 /*return*/, true];
        });
    }); },
};
export default exportSubCategory;
//# sourceMappingURL=exportSubCategory.js.map